__turbopack_context__.v({
  "cta": "XqP37W_cta",
  "highlighted-feature-description": "XqP37W_highlighted-feature-description",
  "highlighted-feature-headline": "XqP37W_highlighted-feature-headline",
  "highlighted-feature-image": "XqP37W_highlighted-feature-image",
  "highlighted-feature-wrapper": "XqP37W_highlighted-feature-wrapper",
  "new-callout": "XqP37W_new-callout",
  "new-callout-wrapper": "XqP37W_new-callout-wrapper",
  "section-title-wrapper": "XqP37W_section-title-wrapper",
});
